module.exports = __webpack_public_path__ + "static/media/job-portal.c7feb9d8.svg";